<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">
      <div class="card">
        <div class="card-title d-flex justify-content-between align-items-center">
          <div class="pl-8">
            <div>
              <button
                type="button"
                class="btn btn-icon btn-outline-primary mr-2"
                style="margin-left: 12px;"
                rippleEffect
                (click)="Back()"
              >
                <span [data-feather]="'arrow-left'"></span>
              </button>
            </div>            
          </div>
          <div class="d-flex justify-content-start align-items-center">            
            <div>
              <div class="pt-1 align-items-left">
                {{ generalResults }}
              </div>              
            </div>             
          </div>  
          <div class="d-flex justify-content-between pl-2">
            <button
              class="btn btn-warning mt-2 mr-1 text-nowrap"
              rippleEffect
              (click)="OpenHistoryModal()"                                    
            >
            <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block text-nowrap">Historial</span>
            </button>      
            <button
              class="btn btn-info mt-2 mr-1 text-nowrap"
              rippleEffect
              (click)="ProccessTemporaryBill()"   
              [disabled]="!canCheck"                         
            >
            <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block text-nowrap">Procesar Factura</span>
            </button>            
            <button type="button" class="btn btn-primary mt-2 mr-1 text-nowrap" rippleEffect (click)="fileInput.click()">
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
                ><span class="d-none d-sm-inline-block text-nowrap">Cargar Factura</span>
            </button>
            <input type="file" id="files" #fileInput style="display: none" (change)="onFileSelected($event)">
          </div>                 
        </div>
        <div class="card-subtitle mb-2 text-muted d-flex justify-content-between align-items-center">
          <div class="align-items-center pl-2" style="font-size: 10; padding-top: 5px;">
            {{ alreadyRegisteredBillsMsg }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <div
              class="d-flex justify-content-between align-items-center m-1"
            >
              <label class="d-flex align-items-center"
                >Mostrando
                <select
                  class="form-control mx-25"
                  [(ngModel)]="basicSelectedOption"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option *ngIf="bills.length > 15" [value]="bills.length">
                    Todos
                  </option>
                </select>
                facturas</label
              >
            </div>
          </div>
          <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div
              class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0"
            >
              <label class="d-flex align-items-center"
                >Buscar<input
                  #searchInput
                  type="search"
                  placeholder="Código Factura"
                  class="form-control ml-25"
                  (keyup)="FilterUpdate(searchInput.value)"
                  (search)="FilterUpdate(searchInput.value)"
              /></label>
            </div>
          </div>
        </div>
        <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-12">
        <ngx-datatable #table ngx-resize-watcher
            [rows]="bills"
            [rowHeight]="58"
            class="bootstrap core-bootstrap"            
            [columnMode]="ColumnMode.flex"
            [headerHeight]="40"
            [footerHeight]="50"
            [scrollbarH]="true"
            [limit]="basicSelectedOption"
            [selected]="selected"
            [selectionType]="SelectionType.checkbox"
            [selected]="selected"           
          [selectionType]="SelectionType.checkbox"
          (activate)="onActivate($event)"
          (select)="onSelect($event)"
            [messages]="{
              emptyMessage: 'No hay información para mostrar',
              totalMessage: 'Total de facturas'
            }"
          > 
          <ngx-datatable-column
            [width]="50"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"  
            prop="idCode"                   
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
              name="SMS"
              title="SMS"              
            >
              <input type="checkbox" [disabled]="!canCheck" [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)" />
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
              title="SMS"
              let-idCode="value"
            >
              <input type="checkbox" ngbTooltip="Enviar SMS" placement="right" [disabled]="CheckIfIsValid(idCode)" [checked]="isSelected" (change)="onCheckboxChangeFn($event, code)" />
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Código" prop="code" [flexGrow]="1">
            <ng-template let-code="value" ngx-datatable-cell-template>      
              <div *ngIf="this.currentStep !== 3 && this.isAdmin && CheckIfBillHasPdf(code);then content else other_content"></div>        
              <ng-template #content>                
                <a *ngIf="this.withPdf && !this.CheckIfBillHasMoreThanOneError(code)" (click)="ConfirmProcessAsAdmin(code)" target="_self" placement="right"  [class.disabled]="CheckIfHasErrors(code) ? true : null" [disabled]="CheckIfHasErrors(code)" [ngbTooltip]="TooltipHelper(code)">
                  {{ code }}
                </a>
                <a *ngIf="!this.withPdf" target="_self" placement="right"  [class.disabled]="CheckIfHasErrors(code) ? true : null" [disabled]="CheckIfHasErrors(code)" [ngbTooltip]="TooltipHelper(code)">
                  {{ code }}
                </a>
                <a *ngIf="this.withPdf && this.CheckIfBillHasMoreThanOneError(code)" target="_self" placement="right"  [class.disabled]="CheckIfHasErrors(code) ? true : null" [disabled]="CheckIfHasErrors(code)" [ngbTooltip]="TooltipHelper(code)">
                  {{ code }}
                </a>
              </ng-template>
              <ng-template #other_content>
                <a *ngIf="this.currentStep !== 3 && this.withPdf" (click)="DownloadPdf(code)" target="_self" placement="right" [class.disabled]="CheckIfHasErrors(code) ? true : null" [disabled]="CheckIfHasErrors(code)" [ngbTooltip]="TooltipHelper(code)">
                  {{ code }}
                </a>
                <a *ngIf="this.currentStep !== 3 && !this.withPdf" target="_self" placement="right" [class.disabled]="!this.withPdf ? true : null" [disabled]="!this.withPdf" [ngbTooltip]="TooltipHelper(code)">
                  {{ code }}
                </a>
                <a *ngIf="this.currentStep === 3" (click)="DownloadPdf(code)" target="_self" placement="right" [class.disabled1]="CheckIfHasErrors(code) ? true : null" [disabled]="CheckIfHasErrors(code)" [ngbTooltip]="TooltipHelper(code)">
                  {{ code }}
                </a>
              </ng-template>
              
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Origen" prop="senderModel" [flexGrow]="1">
            <ng-template let-sender="value" ngx-datatable-cell-template>
              <div
                placement="left"
                [ngbTooltip]="'Nombre: ' + sender?.senderName"
              >
                <span
                  class="d-inline-block text-truncate"
                  style="max-width: 150px"
                  >{{ sender?.senderPhone | limitText }}</span
                >
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Libras" prop="pounds" [flexGrow]="1">
            <ng-template let-pounds="value" ngx-datatable-cell-template>              
              {{ pounds | number: '1.2-2'}}       
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Total" prop="total" [flexGrow]="1">
            <ng-template let-total="value" ngx-datatable-cell-template>
              {{ total | currency }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Fecha" prop="paidAt" [flexGrow]="1">
            <ng-template let-paidAt="value" ngx-datatable-cell-template>
              {{ paidAt | date : "mediumDate" }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Resultado" prop="message" class="msg-full" [flexGrow]="1">
            <ng-template let-message="value" ngx-datatable-cell-template>
              <div container="body" placement="left" [ngbTooltip]="message">
                <ng-container *ngIf="message === 'Factura registrada satisfactoriamente.'; else rejected">
                  <div *ngIf="this.currentStep != 3; else procesada" class="badge bg-success">
                    Aceptada
                  </div>
                  <ng-template #procesada>
                    <div class="badge bg-info">
                      Procesada
                    </div>
                    
                  </ng-template>
                </ng-container>
                <ng-template #rejected>
                  <div class="badge bg-danger" role="alert">
                    Rechazada
                  </div>
                </ng-template>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-footer *ngIf="true">
            <ng-template
              ngx-datatable-footer-template
              let-rowCount="rowCount"
              let-pageSize="pageSize"
              let-selectedCount="selectedCount"
              let-curPage="curPage"
              let-offset="offset"
            >
            <div class="d-flex justify-content-between w-100">
              <div *ngIf="this.currentStep == 2" class="col-7 col-lg-7 col-sm-7" style="padding: 5px 10px">                
                <div>Total facturas: {{ rowCount }} | Total libras: {{ totalPounds() | number :'1.2-2' }} | Total cobrado: {{ totalPaid() | currency}}</div>
              </div>
              <div class="col-5 col-lg-5 col-sm-5 align-items-center align-self-end text-right text-nowrap">
                  <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="curPage"
          [visiblePagesCount]="currentVisible"
          [size]="pageSize"
          [count]="rowCount"
          [hidden]="!((rowCount / pageSize) > 1)"
          (change)="table.onFooterPage($event)">                
              </datatable-pager>
                </div>
            </div>
            
            
              
              
            </ng-template>
          </ngx-datatable-footer>
          </ngx-datatable>
          </div></div></div>
      </div>
      <ng-template #popoverTemplate> 
        <div class="col-md-12 col-12">
          <div class="row pb-1">
              <div class="col-md-12">
                  <button type="button" class="close" (click)="popOver.close()" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              
          </div>  
          Procesar factura como administrador                     
          <button type="button" ngbTooltip="Eliminar" placement="left"
                                        class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-50"
                                        rippleEffect >
                                        <span [data-feather]="'trash-2'"></span></button>
      </div>             
      </ng-template>
    </section>
  </div>
</div>
